import React from 'react';
import * as S from '../styled';
import * as ST from './styled';
import { sectionData } from './section-data';

const renderList = () => {
    return (
        sectionData.map(({ id, title, text }) => (
            <ST.ListItem key={id}>
                <S.DataTitle isLight>{title}</S.DataTitle>
                <S.DataText isLight>{text}</S.DataText>
            </ST.ListItem>
        ))
    );
};

export const HeadSection = () => {
    return (
        <ST.Section bgColor='#000914'>
            <S.InnerContainer>
                <ST.HeadTitle>Онлайн-кинотеатр Дом.ru</ST.HeadTitle>
                <ST.HeadText>
                    Кинотеатр у вас дома. Соберите семью и друзей за последними новинками кино, или устройте вечер просмотра старых советских фильмов.
                </ST.HeadText>
                <S.DataLink href='https://movix.ru'>Перейти на movix.ru</S.DataLink>
            </S.InnerContainer>
            <S.ImgWrap>
                <S.Img src='/static/images/domru-tv/look/heroscreen.png' alt=''/>
            </S.ImgWrap>
            <ST.BottomWrap>
                <S.InnerContainer>
                    <ST.List>
                        {renderList()}
                    </ST.List>
                </S.InnerContainer>
            </ST.BottomWrap>
        </ST.Section>
    );
};
